/**
 * A refusal's message without the field path that a validator puts in front of it.
 *
 * Better Auth answers a malformed sign-in with `[body.email]Invalid email address`, and a Zod
 * issue can arrive the same way. The path names a field of the request body. It means nothing to
 * the person reading the message, and the form already shows which field the message is about.
 */
export function cleanErrorMessage(message: string): string {
  const cleaned = message.replace(/^\[(?:body\.)?[^\]]+\]\s*/i, '').trim()
  return cleaned === '' ? message.trim() : cleaned
}
